import { render, staticRenderFns } from "./Linhas.vue?vue&type=template&id=fe97bb14"
import script from "./Linhas.vue?vue&type=script&lang=js"
export * from "./Linhas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports